import { NewApplicationStatus } from '../types';

const getApplicationStatus = (status: NewApplicationStatus) => {
  let applicationStatus: string;

  switch (status) {
    case NewApplicationStatus.ACCEPTED:
      applicationStatus = 'Accepted';
      break;
    case NewApplicationStatus.DECLINED:
      applicationStatus = 'Declined';
      break;
    case NewApplicationStatus.INCOMPLETE:
      applicationStatus = 'Incomplete';
      break;
    case NewApplicationStatus.READY_TO_REVIEW:
      applicationStatus = 'Waiting for review';
      break;
    case NewApplicationStatus.REVIEW_IN_PROGRESS:
      applicationStatus = 'Review in progress';
      break;
    default:
      applicationStatus = status;
      break;
  }

  return applicationStatus;
};

export default getApplicationStatus;
